import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components'
import { connect } from 'react-redux';
import { searchFacultyActions, searchFacultySelectors } from "../../store/searchFaculty";
import { Box, Card, Flex } from "rebass";
import { Input } from "reakit";
import { SearchButton } from "../Base/Buttons";

const Wrapper = styled(Card)`
z-index: 9100
`;

const ButtonWrapper = styled(Box)`
	min-width: 45px;
	max-width: 45px;
`

const InputWrapper = styled(Box)`
	width: calc(100% - 45px);
	input:focus {
		outline: none;
	}
`

class SearchFacultyInput extends Component {

  componentDidMount() {
    this.props.clearSearch()
  }

  handleSearchSubmit = (e) => {
    e.preventDefault()
  };

  handleSearchInput = (e) => {
    const { updateSearch } = this.props;
    e.preventDefault();
    updateSearch(e.target.value)
  };

  render() {
    const { search } = this.props;

    return (
      <Wrapper bg={'white'} boxShadow={'main'}>
        <form onSubmit={this.handleSearchSubmit} style={{ width: '100%' }}>
          <Flex width={1} flexWrap={'wrap'} flexDirection={'row'}>
            <ButtonWrapper >
              <SearchButton type={'submit'} />
            </ButtonWrapper>
            <InputWrapper>
              <Input fontWeight={'normal'} onChange={this.handleSearchInput} value={search} placeholder="Search Faculties" width={'100%'} />
            </InputWrapper>
          </Flex>
        </form>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  search: searchFacultySelectors.refreshSearch(state.searchFaculty)
});

const mapDispatchToProps = dispatch => ({
  updateSearch: (term) => {
    dispatch(searchFacultyActions.updateSearch(term));
  },
  clearSearch: () => {
    dispatch(searchFacultyActions.clearSearch());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchFacultyInput));
